import { Config } from '@leverege/plugin';
export default class DefaultHistoryQueryTriggerHandler {
  constructor(opts, cxt) {
    this.options = opts;
    this.context = cxt;
    this.timerId = null;
    this.refreshTime = Config.get('HistoryView', 'refreshTime', 60000);
  }
  preQuery() {
    clearTimeout(this.timerId);
  }
  postQuery() {
    // const { delegate, dataViewerInstanceId } = this.options
    // const data = delegate.historyDelegate.getList( GlobalState.get(), dataViewerInstanceId.current, { getAll : true } )

    if (this.options.shouldReloadData?.() !== false) {
      this.timerId = setTimeout(this.options.loadData, this.refreshTime);
    }
  }
  onQueryError(err) {
    this.postQuery();
  }
  init = async () => {
    this.options.loadData();
  };
  cleanup() {
    clearTimeout(this.timerId);
  }
}